import roleAPI from '@/api/role';

const getRoles = async (context, ) => {
  const response = await roleAPI.getRoles();
  if (response.status) {
    context.commit('setRoles', response.data);
  }
}

let actions = {
  getRoles
}

export default actions;
